import React from 'react';
import { Spinner } from '@dropbox/dig-components/progress_indicators';
import { useCurrentPreviewMetadata } from 'js/file_viewer/core/queries/preview_metadata';
import { useTextDataQuery } from 'js/file_viewer/core/queries/riviera_preview_types/text';
import { asyncComponent } from 'js/file_viewer/core/utils/suspense';
import { useDownloadSucceeded } from 'js/file_viewer/hooks/lifecycle_logging';
import * as css from 'js/file_viewer/preview_text/preview_text.module.css';
const AsyncPreviewText = asyncComponent('PreviewText', () => import('js/file_viewer/preview_text/preview_text'));
export const AsyncPreviewTextWithRivieraFetch = (props) => {
    const previewMetadata = useCurrentPreviewMetadata();
    const { data: { apiData: fileContent } = {}, isLoading } = useTextDataQuery(props.previewKey, previewMetadata);
    useDownloadSucceeded(props.previewSessionId, fileContent !== undefined);
    if (isLoading) {
        return (React.createElement("div", { className: css.spinnerContainer },
            React.createElement(Spinner, { size: "large" })));
    }
    return React.createElement(AsyncPreviewText, { ...props, fileContent: fileContent });
};
AsyncPreviewTextWithRivieraFetch.displayName = "AsyncPreviewTextWithRivieraFetch"
//# sourceMappingURL=async_preview_text.preenvesnextjs.map
